const routes = [
  {
    // 巡更记录列表
    path: "/elePatrol-patrolrecord",
    name: "patrolrecord",
    component: () => import("./view/PatrolRecord.vue"),
    meta: {
      requireAuth: false,
      routerAlive: true
    }
  },
  {
    path: "/elePatrol-patrolrecordDetail",
    name: "PatrolRecordDetail",
    component: () => import("./view/Main.vue"),
    meta: {
      module: "elePatrol-patrolrecord",
    }
  }
];
export default routes;
